import { Box, FormControl, FormLabel, Select } from '@chakra-ui/react'
import { useFormContext } from 'react-hook-form'

import { RadioStack } from '../../components/RadioStack'
import { RadioIconGroup } from '../../components/RadioIconGroup'
import { RadioIcon } from '../../components/RadioIcon'

const Description = ({ items }: { items: Array<string> }) => {
  return (
    <Box as="ul" sx={{ fontSize: 'sm', listStyle: 'none', textAlign: 'center' }}>
      {items.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </Box>
  )
}

export const SmeBusinessAreaSelector = () => {
  const { control, register } = useFormContext()

  return (
    <Box sx={{ display: 'grid', gap: 8 }}>
      <FormControl>
        <RadioIconGroup control={control} name="businessArea">
          <RadioStack sx={{ gridTemplateColumns: { base: 'unset', lg: 'repeat(5, 1fr)' } }}>
            <RadioIcon
              value="retail"
              icon="retail"
              description={
                <Description items={['Potraviny', 'Oděvy', 'Lékárna', 'Trafika', 'a další...']} />
              }
            >
              Obchod
            </RadioIcon>
            <RadioIcon
              value="craft"
              icon="craft"
              description={
                <Description
                  items={['Zednictví', 'Topenářství', 'Pokrývačství', 'Truhlářství', 'a další...']}
                />
              }
            >
              Řemesla
            </RadioIcon>
            <RadioIcon
              value="gastro"
              icon="gastro"
              description={
                <Description
                  items={['Hotel', 'Penzion', 'Bary a hospody', 'Restaurace', 'a další...']}
                />
              }
            >
              Gastro a ubytování
            </RadioIcon>
            <RadioIcon
              value="services"
              icon="services"
              description={
                <Description
                  items={['Kadeřnictví', 'Manikúra', 'Znalci', 'Realitky', 'a další...']}
                />
              }
            >
              Služby
            </RadioIcon>
            <RadioIcon
              value="production"
              icon="production"
              description={
                <Description
                  items={[
                    'Výroba potravin',
                    'Výroba textilu',
                    'Kovovýroba',
                    'Malé a střední sklady',
                    'a další...',
                  ]}
                />
              }
            >
              Výroba a sklady
            </RadioIcon>
          </RadioStack>
        </RadioIconGroup>
      </FormControl>

      <FormControl>
        <FormLabel sx={{ fontSize: 'xl' }}>
          Vyberte obor podnikání, ze kterého máte nejvyšší příjmy
        </FormLabel>

        <Select {...register('businessAreaDomain')}>
          <option value="" disabled>
            Vyberte obor…
          </option>
          <option value="Domácí elektronika a fototechnika">
            Domácí elektronika a fototechnika
          </option>
          <option value="Hračky, sport, volný čas (mimo bazarů)">
            Hračky, sport, volný čas (mimo bazarů)
          </option>
          <option value="Knihy, časopisy a hudebniny (mimo bazarů)">
            Knihy, časopisy a hudebniny (mimo bazarů)
          </option>
          <option value="Zahradnictví, květinářství, chovatelské potřeby a petcentra">
            Zahradnictví, květinářství, chovatelské potřeby a petcentra
          </option>
          <option value="Lékárny, zdravotnické potřeby, kosmetiky a parfumerie">
            Lékárny, zdravotnické potřeby, kosmetiky a parfumerie
          </option>
          <option value="Nábytek (mimo bazarů)">Nábytek (mimo bazarů)</option>
          <option value="Optika">Optika</option>
          <option value="Potraviny (maso, uzeniny, pekařství, ovoce, zelenina), koloniál (nápoje)">
            Potraviny (maso, uzeniny, pekařství, ovoce, zelenina), koloniál (nápoje)
          </option>
          <option value="Smíšené zboží a kancelářské potřeby">
            Smíšené zboží a kancelářské potřeby
          </option>
          <option value="Textil, oděvy, obuv, dětský textil, kožené zboží, spodní prádlo, doplňky (mimo bazarů)">
            Textil, oděvy, obuv, dětský textil, kožené zboží, spodní prádlo, doplňky (mimo bazarů)
          </option>
          <option value="Trafiky (tiskoviny, tabák)">Trafiky (tiskoviny, tabák)</option>
          <option value="Výpočetní technika a počítače">Výpočetní technika a počítače</option>
          <option value="Železářství, domácí a výtvarné potřeby">
            Železářství, domácí a výtvarné potřeby
          </option>
        </Select>
      </FormControl>
    </Box>
  )
}
